/* yourtheone — PDP モバイル並び替え：先頭画像 → 商品情報/サイズ/配送 → 残り画像（2枚目以降）
   dearcouple構成準拠。実Dawn出力(main-product)に対して動作。デスクトップは元の縦積みのまま。 */
(function () {
  function setup(product) {
    if (product.__ytMediaStack) return;
    var info = product.querySelector('.product__info-wrapper');
    var list = product.querySelector('.product__media-list');
    if (!info || !list) return;
    var items = Array.prototype.slice.call(list.children).filter(function (el) {
      return el.classList && el.classList.contains('product__media-item');
    });
    if (items.length < 2) return; // 1枚なら並び替え不要
    product.__ytMediaStack = true;

    var rest = items.slice(1); // 2枚目以降
    var holder = document.createElement('ul');
    holder.className = 'yt-media-rest';
    var state = null;

    function apply() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      if (mobile === state) return;
      state = mobile;
      if (mobile) {
        // info の直後に holder を置き、残り画像をそこへ移動
        if (info.nextSibling !== holder) info.parentNode.insertBefore(holder, info.nextSibling);
        rest.forEach(function (it) { holder.appendChild(it); });
      } else {
        // デスクトップ：元の media list に順番通り戻す
        rest.forEach(function (it) { list.appendChild(it); });
        if (holder.parentNode) holder.parentNode.removeChild(holder);
      }
    }
    apply();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 150); });
  }

  function boot() {
    document.querySelectorAll('.product').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
